<template>
  <div class="row page-content-full-width">
    <div class="col-12">
      <div class="row header justify-content-center no-gutters">
        <div class="col-12">
          <h2 v-if="isIIProject || isAVGProject" class="mb-2 mt-5">
            <img :src="renderIIlogo()" class="ii-logo" />
          </h2>
          <h2 v-else class="mb-0 mt-5">
            Data Server
          </h2>
        </div>
      </div>
      <div class="row header justify-content-center no-gutters">
        <div class="col-12">
          <h4>{{ 'restore_password' | i18n }}</h4>
        </div>
      </div>
      <div class="row form-container justify-content-center no-gutters">
        <div class="col col-xs-12 col-md-8 col-lg-6 col-xl-4 no-gutters">
          <b-form @submit="onSubmit">
            <b-form-group>
              <b-form-input
                id="password"
                v-model="formData.password"
                type="password"
                class="form-control"
                :placeholder="'new_password' | i18n"
                size="sm"
              />
            </b-form-group>
            <b-form-group>
              <b-form-input
                id="confirm_password"
                v-model="formData.confirmPassword"
                type="password"
                class="form-control"
                :placeholder="'confirm_new_password' | i18n"
                size="sm"
              />
            </b-form-group>
            <b-button type="submit" variant="primary" class="btn-sign-in" :disabled="!isFormValid" size="sm">
              {{ 'save' | i18n }}
            </b-button>
            <div class="login-link" @click="goToSignIn">
              {{ 'go_to_sign_in' | i18n }}
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthMixin, NavigationMixin, NotificationMixin, LicenseMixin } from '../mixins';
import IIlogo from '../assets/logo-ii-text.png';
import digital35Logo from '../assets/digital35.png';
import sensisLogo from '../assets/sensis-logo.svg';

export default {
  name: 'SignIn',
  mixins: [AuthMixin, NavigationMixin, NotificationMixin, LicenseMixin],
  data: function() {
    return {
      formData: { password: null, confirmPassword: null },
      isFormValid: false
    };
  },
  watch: {
    formData: {
      handler: function(value) {
        this.isFormValid =
          typeof value.confirmPassword === 'string' && value.confirmPassword !== '' && typeof value.password === 'string' && value.password !== '';
      },
      deep: true
    }
  },
  methods: {
    renderIIlogo() {
      if (this.isAVGProject || this.isEKAVProject) {
        return sensisLogo;
      }
      if (this.isDIGITAL35Project) {
        return digital35Logo;
      }
      return IIlogo;
    },
    async onSubmit(evt) {
      evt.preventDefault();
      console.log(this.$route.query, 'this.$route.query');
      try {
        if (!this.$route.query.token && !this.$route.query.email) {
          throw 'not token';
        }
        if (this.formData.password !== this.formData.confirmPassword) {
          return this.showNotification({
            type: 'error',
            title: this.$translate('different_passwords'),
            message: '  '
          });
        }
        await this.authService.restorePassword({
          email: this.$route.query.email,
          password: this.formData.password,
          token: this.$route.query.token
        });
        this.goToSignIn();
        this.showNotification({
          type: 'success',
          title: this.$translate('restore_password'),
          message: this.$translate('success')
        });
      } catch (err) {
        this.showNotification({
          type: 'error',
          title: this.$translate('restore_password'),
          message: this.$translate('restore_link_not_valide')
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  text-align: center;
}

.header {
  margin-top: 20px;

  h3 {
    margin-left: 0;
  }
}

.form-container {
  margin-top: 25px;
}

.btn {
  height: 40px;
  line-height: 24px;
  font-size: 1rem;

  &.btn-sign-in {
    width: 100%;
  }
}
.login-link {
  color: rgb(3, 102, 214);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  margin-top: 20px;
}
.ii-logo {
  height: 75px;
}
</style>
